import React, {useEffect} from 'react'
import { Form, Steps } from 'antd'
import {
    TrialButton,
    PreLoginInput,
    StyledButtonContainer
} from 'views/PreLogin/styled'
import {stepsDetails} from './data';
import { apiClient } from 'utils/api-client'


function UrlStep({ form, setStep, setErrorMessage, setToken, setScanDetails }) {
    const { getFieldDecorator } = form

	const onSubmit = (event) => {
        event.preventDefault();
        form.validateFields().then((values) => {
            apiClient(`/trial/validate`, {
                body:{root_url: values.rootUrl}
            })
            .then(() => {
                const {admin_first_name, admin_last_name, admin_email, admin_password, account_name, phone} = values;
                apiClient(`/account/sign-up-trial`, {
                    body:{admin_first_name, admin_last_name, admin_email, admin_password, account_name, phone}
                })
                .then((tokenResponse) => {
                    setToken(tokenResponse.data);
                    const token = tokenResponse.data.access_token;
                    apiClient(`/trial/create`, {
                        body:{root_url: values.rootUrl},
                        headers: {Authorization: `Bearer ${token}` }
                    })
                    .then((scanResponse) => {
                        setScanDetails(scanResponse.data);
                        setStep(stepsDetails[2].name);
                        setErrorMessage(null);
                    })
                    .catch((ex) => {
                        //create scan settings and run scan errors
                        setErrorMessage(ex?.response?.data?.Errors);
                    });
                })
                .catch((ex) => {
                    //create account errors
                    setErrorMessage(ex?.response?.data?.Errors);
                });
            })
            .catch((ex) => {
                //validate url errors
                setErrorMessage(ex?.response?.data?.Errors);
            });
        });
    }
    
	return (
		<div>		
            {
                <Form.Item>
                    {getFieldDecorator("rootUrl", {
                        validateTrigger: ['onChange', 'onBlur'],
                        rules: [
                            {
                                required: true,
                                whitespace: true,
                                message: "Website url is Required"
                            }
                        ]
                    })(<PreLoginInput placeholder="HTTPS://MYWEBSITE.COM" />)}
                </Form.Item>
            }
            <StyledButtonContainer>
                <TrialButton  onClick={onSubmit} size="large" type="primary" htmlType="submit">
					SCAN WEBSITE
				</TrialButton>
			</StyledButtonContainer>
		</div>
	)
}
export default UrlStep;
